export function interpolieren(xm, x1, x2, y1, y2) {
  let ym = ((xm - x1) / (x2 - x1)) * (y2 - y1) + y1;
  return ym;
}

export function calculateHydraulischerDurchmesser({
  Kulissenspaltbreite,
  Kulissenhoehe,
  AnzahlKulissen,
}) {
  let s = Kulissenspaltbreite / 1000; //in Meter
  let b = Kulissenhoehe / 1000; // in Meter
  let AnzahlKulissenValue = AnzahlKulissen; //Anzahl Kulissen == Anzahl Spalten
  let dh = 0;

  dh = 2 * b * AnzahlKulissenValue * s / (b + AnzahlKulissenValue * s);
  return dh;
}

export function calculateZeta({
  Kulissenspaltbreite,
  Kulissenbreite,
  Kulissenhoehe,
  Kulissenlaenge,
  AnzahlKulissen,
}) {
  let kulissenbreite = Number(Kulissenbreite);
  let a1 = 0.235;
  let b1 = -2.78;
  let a2 = 0.017;
  let b2 = -2.70;
  if (kulissenbreite === 100) {
    a1 = 0.235;
    b1 = -2.78;
    a2 = 0.017;
    b2 = -2.70;
  }
  else if (kulissenbreite < 200 && kulissenbreite > 100) {
    let _100a1 = 0.235;
    let _100b1 = -2.78;
    let _100a2 = 0.017;
    let _100b2 = -2.70;

    let _200a1 = 0.255;
    let _200a2 = 0.015;
    let _200b1 = -2.82;
    let _200b2 = -2.91;

    a1 = interpolieren(kulissenbreite, 100, 200, _100a1, _200a1);
    a2 = interpolieren(kulissenbreite, 100, 200, _100a2, _200a2);
    b1 = interpolieren(kulissenbreite, 100, 200, _100b1, _200b1);
    b2 = interpolieren(kulissenbreite, 100, 200, _100b2, _200b2);
  }
  else if (kulissenbreite === 200) {
    a1 = 0.255;
    a2 = 0.015;
    b1 = -2.82;
    b2 = -2.91;
  }

  else if (kulissenbreite > 200 && kulissenbreite < 300) {
    let _200a1 = 0.255;
    let _200a2 = 0.015;
    let _200b1 = -2.82;
    let _200b2 = -2.91;

    let _300a1 = 0.294;
    let _300a2 = 0.0167;
    let _300b1 = -2.83;
    let _300b2 = -2.95;

    a1 = interpolieren(kulissenbreite, 200, 300, _200a1, _300a1);
    a2 = interpolieren(kulissenbreite, 200, 300, _200a2, _300a2);
    b1 = interpolieren(kulissenbreite, 200, 300, _200b1, _300b1);
    b2 = interpolieren(kulissenbreite, 200, 300, _200b2, _300b2);
  }

  if (kulissenbreite === 300) {
    a1 = 0.294;
    a2 = 0.0167;
    b1 = -2.83;
    b2 = -2.95;
  }

  let s = Kulissenspaltbreite / 1000; // in Meter
  let dk = kulissenbreite / 1000; //in Meter
  let dh = calculateHydraulischerDurchmesser({
    Kulissenspaltbreite,
    Kulissenhoehe,
    AnzahlKulissen,
  });
  let L = Kulissenlaenge / 1000; //in Meter

  let zeta1 = a1 * Math.pow((s / (s + dk)), b1);
  let zeta2 = a2 * Math.pow((s / (s + dk)), b2);

  let zeta = zeta1 + zeta2 * L / dh;
  return zeta;
}

export function calculateDruckverlust({
  Anstroemgeschwindigkeit,
  Kulissenspaltbreite,
  Kulissenbreite,
  Kulissenhoehe,
  Kulissenlaenge,
  AnzahlKulissen,
}) {
  let luftdichte = 1.225; //[kg/m³]
  let zeta = calculateZeta({
    Kulissenspaltbreite,
    Kulissenbreite,
    Kulissenhoehe,
    Kulissenlaenge,
    AnzahlKulissen,
  });
  let anstroemgeschwindigkeit = Anstroemgeschwindigkeit;
  let detaP = zeta * luftdichte / 2 * Math.pow(anstroemgeschwindigkeit, 2);
  return detaP;
}
